/**
 * Migrate old config format (removeTags) to new format (entities + dynamicTagging).
 * Old: { configuration: {...}, removeTags: ["PERSON", "LOCATION"] }
 * New: { dynamicTagging: {...}, entities: {...}, configuration: {...} }
 */
export function migrateConfig(config) {
    if (!config) return null;
    const parsed = typeof config === "string" ? JSON.parse(config) : config;

    // Already new format — has entities as object (not array)
    if (parsed.entities && typeof parsed.entities === "object" && !Array.isArray(parsed.entities)) {
        return parsed;
    }

    // Old format: convert removeTags to entities
    const removeTags = parsed.removeTags || [];
    const entities = {};
    removeTags.forEach(tag => {
        entities[tag] = { labels: [] };
    });

    const migrated = {
        configuration: parsed.configuration || { nlp_engine_name: "spacy", models: [] }
    };

    if (Object.keys(entities).length > 0) {
        migrated.entities = entities;
    }

    // Preserve dynamicTagging if it already exists
    if (parsed.dynamicTagging) {
        migrated.dynamicTagging = parsed.dynamicTagging;
    }

    // Preserve privacyFilter if it already exists
    if (parsed.privacyFilter) {
        migrated.privacyFilter = parsed.privacyFilter;
    }

    // Preserve trainedTagging if it already exists
    if (parsed.trainedTagging) {
        migrated.trainedTagging = parsed.trainedTagging;
    }

    return migrated;
}

export function isLegacyConfig(config) {
    if (!config) return false;
    const parsed = typeof config === "string" ? JSON.parse(config) : config;
    return Array.isArray(parsed.removeTags);
}
